/**
 * Post Create Render
 *
 * Rendering helpers for ratings, media tiles, and create-form UI fragments.
 */

import { CommonUtils } from "../../util/common-utils";

function renderRatingStarsPreview(container: HTMLElement | null | undefined, rating: number): void {
    if (!(container instanceof HTMLElement)) return;

    const base = Number.isFinite(rating) ? rating : 0;
    const html = Array.from({ length: 5 }, (_, index) => {
        const starNumber = index + 1;
        const stateClass =
            starNumber <= Math.floor(base)
                ? "star-preview-icon--filled"
                : starNumber === Math.floor(base) + 1 && base % 1 >= 0.5
                  ? "star-preview-icon--half"
                  : "star-preview-icon--empty";

        return `<i class="star-preview-icon ${stateClass}">★</i>`;
    }).join("");

    container.innerHTML = html;
}

function renderMediaTiles(container: HTMLElement | null | undefined, tiles: HTMLElement[]): void {
    if (!(container instanceof HTMLElement)) return;

    CommonUtils.setHtml(container, "");
    (Array.isArray(tiles) ? tiles : []).forEach((tile) => {
        if (tile instanceof HTMLElement) {
            container.appendChild(tile);
        }
    });
}

function restoreSubmitButtonState(
    submitBtn: HTMLElement | null | undefined,
    originalText: string | null,
    originalDisabled: boolean,
): void {
    if (submitBtn instanceof HTMLButtonElement) {
        submitBtn.innerHTML = String(originalText || "");
        submitBtn.disabled = !!originalDisabled;
        return;
    }

    if (submitBtn instanceof HTMLInputElement) {
        submitBtn.value = String(originalText || "");
        submitBtn.disabled = !!originalDisabled;
    }
}

export { renderMediaTiles, renderRatingStarsPreview, restoreSubmitButtonState };
